import i18n from 'modules/core/lib/i18n'

export type TabsIdsEnum = 'personal' | 'team'

export const TabsIdsEnumValues: TabsIdsEnum[] = ['personal', 'team']

interface Tab {
  id: TabsIdsEnum
  label: string
}

export const buildTargetPageTabs = () => {
  const tabs: Tab[] = [
    {
      id: 'personal',
      label: i18n.t('performance_process.targets.personal'),
    },
    {
      id: 'team',
      label: i18n.t('performance_process.targets.team'),
    },
  ]

  return tabs
}
